import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import MultiSelect, { MultiSelectProps } from 'components/MultiSelect';

import { ServicesSelect_data$key } from '__generated__/ServicesSelect_data.graphql';

type Props = {
  data: ServicesSelect_data$key;
} & MultiSelectProps;

const ServicesSelect: FC<Props> = ({ data, ...rest }) => {
  const { allServices } = useFragment(
    graphql`
      fragment ServicesSelect_data on Query {
        allServices {
          id
          name
        }
      }
    `,
    data
  );

  return (
    <MultiSelect label="Priskirtos paslaugos" options={allServices} {...rest} />
  );
};

export default ServicesSelect;
